module.exports = __webpack_public_path__ + "static/media/self_assessment_intro.c6b56444.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/self_assessment_intro.svg
// module id = 1861
// module chunks = 0